import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registrarWebVital } from './utils/webVitals';
import { registrarServiceWorker } from './utils/serviceWorker';
import { instalarCapturaGlobal } from './utils/reportarErro';

// Erros não tratados (render fora do ErrorBoundary, promises) vão para o log
// estruturado do backend via `POST /api/client-errors` (best-effort).
instalarCapturaGlobal();

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30000,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals(registrarWebVital);

// Service worker: necessário para Web Push. Não faz cache de assets (ver sw.js).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    registrarServiceWorker().catch((error) => {
      console.warn('[ServiceWorker] Falha ao registrar:', error);
    });
  });
}

// Captura antecipada do prompt de instalação do PWA (Chrome/Edge/Android).
window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault();
  window.__pwaInstallPrompt = event;
  window.dispatchEvent(new CustomEvent('pwa-install-available'));
});
